"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapWithRouterReduxContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const connected_react_router_1 = require("connected-react-router");
const react_router_1 = require("react-router");
/*
    Override ConnectedRouter type as connected-react-router doesn't support PropsWithChildren
    https://ru.reactjs.org/blog/2022/03/08/react-18-upgrade-guide.html#updates-to-typescript-definitions
    https://github.com/supasate/connected-react-router/issues/573
*/
const ConnectedRouterWithChildren = connected_react_router_1.ConnectedRouter;
const wrapWithRouterReduxContainer = (BaseComponent, { history }) => {
    const WrappedComponent = (props) => {
        return ((0, jsx_runtime_1.jsx)(ConnectedRouterWithChildren, { history: history, children: (0, jsx_runtime_1.jsx)(react_router_1.Switch, { children: (0, jsx_runtime_1.jsx)(react_router_1.Route, { path: "/", render: () => (0, jsx_runtime_1.jsx)(BaseComponent, Object.assign({}, props)) }) }) }));
    };
    return WrappedComponent;
};
exports.wrapWithRouterReduxContainer = wrapWithRouterReduxContainer;
//# sourceMappingURL=routerReduxWrapper.js.map